import { LinkButton, Stack, Text, Heading, Box, Title, Graphic, Divider } from '@thirstycamel/ui'
import React, { memo } from 'react'

import LayoutMain from '../layout/LayoutMain'
import LoginForm from '../components/LoginForm'
import { useRouter } from 'next/router'

const Login = () => {
  const router = useRouter()

  const handleLoginSuccess = () => {
    const redirectTo = (router.query.redirectTo as string) || '/account/offers'
    const redirectToAs = (router.query.redirectToAs as string) || redirectTo
    router.push(redirectTo, redirectToAs)
  }

  return (
    <LayoutMain requireNoAuth title="Login" bg="gray.50">
      <Stack
        flex="1 1 0"
        border={[, , '2px']}
        borderColor={[, , 'gray.200']}
        pt={6}
        pb={8}
        pr={[5, null, 10]}
        pl={[5, null, 10]}
        mt={12}
        mb={16}
        spacing={6}
        bg="white"
        boxShadow="md"
        maxWidth={['26rem', , , '30rem']}
        borderRadius="lg"
        mx="auto"
      >
        <Box position="relative">
          <Graphic
            name="humpClubLogo"
            transform="rotate(-10deg)"
            size="8rem"
            pos="absolute"
            bottom="-2rem"
            right={['calc(50%)', , 'calc(50% + 2rem)']}
          />

          <Title textAlign="center" ml={[10, , 4]}>
            Sign in
          </Title>
        </Box>

        <LoginForm onSuccess={handleLoginSuccess} />

        <Divider />

        <Stack textAlign="center">
          <Heading fontSize="sm">Don't have an account?</Heading>
          <Text>No worries! Sign up to Hump Club today.</Text>
        </Stack>

        <LinkButton href="/register" variant="outline" variantColor="pink">
          Create account
        </LinkButton>

        {/* <Text fontSize="sm" textAlign="center">
          Start using your membership for your chance to get $5 or $100 off, every 1 in 10 wins!
        </Text>

        <LinkButton variantColor="pink" variant="outline" href="/win" width="100%">
          VIEW LIVE WINNERS
        </LinkButton> */}
      </Stack>
    </LayoutMain>
  )
}

export default memo(Login)
